VGTierApp.CartPage.Show_CalculateTier = function () {

    var currencySymbol = globalFields.currencySymbol, isCartPage = globalFields.isCartPage, isProductPage = globalFields.isProductPage;
    var cartItemsCart = commonFields_CD.cartItemsCart, originalCartSubtotal = 0, priceDiff = 0, discountOff = 0, lastMinTier = 0;
	var discounttype = ''; var isPercentage = true;
    var TieredPricingCart = function (cartItems, isUpdate, isCartPage) {
        originalCartSubtotal = cartItems.original_total_price;
        var tiers = cartItems.tierPricing; priceDiff = 0;
        var updatedCartSubTotal = 0;
        if (tiers != "" && tiers.split(',')[5] === 'true' && globalFields.StartEndDateValid(tiers.split(','))) {
            var isNotInRange = true, tierPricing = tiers;
            var splitTierPricing = tierPricing.split(',');
          if(splitTierPricing[0].trim() == "percentage")
          {
            discounttype = splitTierPricing[0].trim();
          }
          else
          {
            discounttype = "fixed_amount";
            isPercentage = false;
          }
            var rslt = CalculateTier(splitTierPricing, originalCartSubtotal, isUpdate, isCartPage, isNotInRange);
            if (rslt[1]) {
                updatedCartSubTotal = CalculateSubtotal(originalCartSubtotal, 0, splitTierPricing[0].trim());
            }
            else {
                updatedCartSubTotal = CalculateSubtotal(originalCartSubtotal, rslt[0], splitTierPricing[0].trim());
                discountOff = rslt[0]; lastMinTier = rslt[2];
            }
        }
        else {
            updatedCartSubTotal = CalculateSubtotal(originalCartSubtotal, 0, 'fixed');
        }

        UpdateCartSubtotal(isUpdate, isCartPage, updatedCartSubTotal, originalCartSubtotal, lastMinTier, isPercentage);

        priceDiff = originalCartSubtotal - updatedCartSubTotal;
        priceDiff = priceDiff.toFixed(2);
        priceDiff = Number(priceDiff);
        cartItemsCart = cartItems;
        UpdateSavingMessage(isUpdate);
    }

    var CalculateTier = function (splitTierPricing, originalCartSubtotal, isUpdate, isCartPage, isNotInRange) {
        var tierOff = 0, minCart = 0;
        for (i = 6; i < splitTierPricing.length; i++) {
            var tierRange = splitTierPricing[i].split('=')[0], tierPrice = splitTierPricing[i].split('=')[1], minTier = parseInt(tierRange.split("-")[0]), maxTier = parseInt(tierRange.split("-")[1]), maxTier = tierRange.split("-")[1];
            if (maxTier != "max") { maxTier = parseInt(tierRange.split("-")[1]); }
            var condition1 = false; var condition2 = false;
            if (originalCartSubtotal >= minTier) { condition1 = true; }
            if (maxTier == "max") { condition2 = true; }
            else if (originalCartSubtotal <= maxTier) { condition2 = true; }

            if (condition1 && condition2) { isNotInRange = false; tierOff = parseFloat(tierPrice); minCart = parseFloat(minTier); }
        }

        return [tierOff, isNotInRange, minCart];
    }

    var ChangeLineItemPrice = function (tierOff, items) {
        for (i = 0; i < items.length; i++) {
            var p = parseFloat(tierOff) / 100;
            var updatedItemPrice = items[i].originalItemPrice / 100; updatedItemPrice = updatedItemPrice.toFixed(2); updatedItemPrice = Number(updatedItemPrice);
            var originalPriceCut = parseFloat(p * updatedItemPrice); originalPriceCut = originalPriceCut.toFixed(2); originalPriceCut = Number(originalPriceCut); updatedItemPrice = updatedItemPrice - originalPriceCut; updatedItemPrice = updatedItemPrice.toFixed(2);
            var updatedLinePrice = items[i].originalLinePrice / 100; updatedLinePrice = updatedLinePrice.toFixed(2); updatedLinePrice = Number(updatedLinePrice);
            var originalLinePriceCut = parseFloat(p * updatedLinePrice); originalLinePriceCut = originalLinePriceCut.toFixed(2); originalLinePriceCut = Number(originalLinePriceCut); updatedLinePrice = updatedLinePrice - originalLinePriceCut; updatedLinePrice = updatedLinePrice.toFixed(2);
            jQuery('.ajaxcart__row').eq(i).find('.vg-ajaxcart-item-total').remove();
            jQuery('tr.cart__row').eq(i).find('td:eq(2)').html('<span style="padding-left: 11px;" class="cart-item__original-price"><s>' + globalFields.currencySymbol + '' + updatedItemPrice + '</s></span>' + '<span class="h3">' + currencySymbol + (items[i].originalItemPrice / 100).toFixed(2) + '</span>');
            jQuery('tr.cart__row').eq(i).find('td:eq(4)').html('<span class="cart-item__original-price"><s>' + globalFields.currencySymbol + '' + updatedLinePrice + '</s></span>' + '<span class="h3">' + currencySymbol + (items[i].originalLinePrice / 100).toFixed(2) + '</span>');
            jQuery('.ajaxcart__row').eq(i).find('span:last').before('<s class="vg-ajaxcart-item-total"><small style="font-size: smaller;">' + globalFields.currencySymbol + (items[i].originalLinePrice / 100).toFixed(2) + '</small></s> ');
            jQuery('.ajaxcart__row').eq(i).find('span:last').html(globalFields.currencySymbol + '' + updatedLinePrice);
        }
    }

    var CalculateSubtotal = function (originalCartSubtotal, tierOff, tierType) {
        var updatedCartSubTotal = 0;
        var originalPriceCut = 0;
        if (tierType == "percentage") {
            var p = parseFloat(tierOff) / 100;
            originalPriceCut = parseFloat(p * originalCartSubtotal);
        }
        else {
            originalPriceCut = tierOff;
        }

        originalPriceCut = originalPriceCut.toFixed(2);
        originalPriceCut = Number(originalPriceCut);
        updatedCartSubTotal = originalCartSubtotal - originalPriceCut;
        return updatedCartSubTotal;
    }


    var UpdateCartSubtotal = function (isUpdate, isCartPage, updatedCartSubTotal, originalCartSubTotal, lastMinTier, isPercentage) {
        if (isUpdate) {
            if (originalCartSubTotal != updatedCartSubTotal) {
              	if(isPercentage == true)
      			{
                var saveHtml = '<div id="vg-subtotal-div" style="font-size: 12px;"><p><span>' + discountOff + '</span>% off over <span class="money">' + currencySymbol + lastMinTier.toFixed(2) + '</span></p></div>'
                }
              	else{
                var saveHtml = '<div id="vg-subtotal-div" style="font-size: 12px;"><p><span class="money">' + currencySymbol + discountOff.toFixed(2) + '</span> off over <span class="money">' + currencySymbol + lastMinTier.toFixed(2) + '</span></p></div>'
              	}
                //var s = MinimumCartTotal > 0 ? 'over ' + currencySymbol + MinimumCartTotal + ') ' : '';
//                 jQuery('.mini-cart__inner .mini-cart__recap-price-line .vg-subtotal').html('<s><span class="money">' + globalFields.currencySymbol + originalCartSubTotal.toFixed(2) + '</span></s> <span class="money">' + globalFields.currencySymbol + updatedCartSubTotal.toFixed(2) + '</span>');
              jQuery('.cart__row .grid__item.one-half:last p.h4').html('<s><span class="money">' + globalFields.currencySymbol + originalCartSubTotal.toFixed(2) + '</span></s> <span class="money">' + globalFields.currencySymbol + updatedCartSubTotal.toFixed(2) + '</span>');
              jQuery('#CartDrawer p.ajaxcart__price').html('<s><span class="money">' + globalFields.currencySymbol + originalCartSubTotal.toFixed(2) + '</span></s> <span class="money">' + globalFields.currencySymbol + updatedCartSubTotal.toFixed(2) + '</span>');
              jQuery('.cart_whole_totle').html('<span class="money">' + globalFields.currencySymbol + updatedCartSubTotal.toFixed(2) + '</span>');
              if(jQuery('#vg-subtotal-div').length < 1){ 
                jQuery('.cart__row .grid__item.one-half:last p.h4').after(saveHtml); 
              }
//               else{ 
//                 jQuery('#vg-subtotal-div').remove();
// //                 jQuery('#CartDrawer p.ajaxcart__price, .cart__row .grid__item.one-half:last p.h4').after(saveHtml); 
//               }
              if(jQuery('#vg-subtotal-div').length < 1){ jQuery('#CartDrawer p.ajaxcart__price').after(saveHtml); }
//               jQuery('.cart-recap__amount-saved span, .mini-cart__amount-saved span').html(Number(originalCartSubTotal - updatedCartSubTotal).toFixed(2));
            }
            else {
                jQuery('.cart__savings').remove();
//                 jQuery('.mini-cart__inner .mini-cart__recap-price-line .vg-subtotal').html('<span class="money">' + globalFields.currencySymbol + updatedCartSubTotal.toFixed(2) + '</span>');
              jQuery('.cart__row .grid__item.one-half:last p.h4').html('<span class="money">' + globalFields.currencySymbol + updatedCartSubTotal.toFixed(2) + '</span>');
              jQuery('#CartDrawer p.ajaxcart__price').html('<span class="money">' + globalFields.currencySymbol + updatedCartSubTotal.toFixed(2) + '</span>');
            }
        }
    }

    var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            var saveHtml = '<h3 id="saved-banner">' + jQuery('#vg-saving-message').text() + ' <span class="money">' + globalFields.currencySymbol + priceDiff.toFixed(2) + '</span></h3>';
            jQuery('#saved-banner-div').length == 0 ? jQuery('form.cart').before('<div id="saved-banner-div" class="col-md-12">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }

    var pagereload = function () {
      jQuery('.quantity-selector__button').click(function () {
        setTimeout('location.reload()', 1000); 
      });
      jQuery('.quantity-selector__value').keyup(function () {
        setTimeout('location.reload()', 1000); 
      });
    }
    
    var CheckoutClickCart = function () {
        jQuery('.drawer__footer button[name="checkout"], form[method="post"] button[name="checkout"]').click(function () {
            GetCode(false);
        });
    }

    var DiscountCodeCookie = function (discount_code) {
        $.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var GetCode = function (isUpper) {
        if (priceDiff > 0) {
            //if (0) {
            $.ajax({
                type: "POST", async: false,
                url: "https://www.vgroupapps.com/TieredPricing/api/services/CartCode",
                data: { discountOff: discountOff, subTotal: originalCartSubtotal, discounType: discounttype },
                success: function (result) {
                    var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
                    var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
                    SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                    if (!isUpper) {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form.cart').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                    } else {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('#ajaxifyCart form.cart-wrapper').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                        //window.location.href = '/checkout?discount=' + DiscountCode;
                    }
                },
                error: function (e) { console.log(e.statusText); }
            });
        }
    }

    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        if (settings !== 'undefined') {
            var splittedUrl = settings.url;
            if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
                splittedUrl = splittedUrl.split("?");
                if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
                    var response = JSON.parse(xhr.responseText);
                    setTimeout(function () {
                        var items = []; for (var i = 0; i < response.items.length; i++) { var item = response.items[i], item1 = { variantId: item.variant_id, originalItemPrice: item.original_price, originalLinePrice: item.original_line_price }; items.push(item1); }
                        var original_total_price = response.original_total_price / 100;
                        cartItemsCart.items = items;
                        cartItemsCart.original_total_price = original_total_price;
                        TieredPricingCart(cartItemsCart, true, isCartPage);
                        CheckoutClickCart();
                    }, 500);
                }
            }
        }
    });

    function SetCookie(cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    setTimeout(function () { TieredPricingCart(cartItemsCart, true); CheckoutClickCart(); }, 4000);
}

var commonFields_CD = new VGTierApp.CartPage.Global(); var cartObject = new VGTierApp.CartPage.Show_CalculateTier();